import React from 'react';

import { Text } from '@change/ds-core-ui';
import { Checkbox } from '@change/ds-forms';

import { useShouldSavePaymentMethodInput } from './hooks/useShouldSavePaymentMethodInput';
import { useTracking } from './hooks/useTracking';

export const ShouldSavePaymentMethodInput: React.FC = () => {
	const {
		data: { displayed, shouldSavePaymentMethod, label },
		actions: { setShouldSavePaymentMethod },
	} = useShouldSavePaymentMethodInput();

	const { trackShouldSavePaymentMethodInputClick, trackShouldSavePaymentMethodInputFocus } = useTracking();

	if (!displayed) return null;

	return (
		<Checkbox
			defaultSelected={shouldSavePaymentMethod}
			name="save_card"
			onFocus={trackShouldSavePaymentMethodInputFocus}
			onChange={() => {
				setShouldSavePaymentMethod(!shouldSavePaymentMethod);
				trackShouldSavePaymentMethodInputClick();
			}}
			data-qa="save_card"
			data-testid="save_card" // TODO: this is here for the regression suite, which should be updated to use the data-qa attribute
		>
			<Text variant="body" className="text-size-body-xs text-typography-strong md:text-size-body-small">
				{label}
			</Text>
		</Checkbox>
	);
};
